// Canonical helpers for classifying Final Jeopardy submissions.
//
// MIRROR file: functions/src/host/submissionClassification.js. CRA cannot
// import from outside src/, so the file is duplicated. Keep behavior
// byte-identical; the parity test in functions/src/host/__tests__/
// finalRevealScript.test.js guards against drift.

export const isSubmissionCorrect = (submission) =>
  submission?.result === 'correct' || submission?.status === 'correct';

export const isNoAnswer = (submission) =>
  !submission?.answer && !isSubmissionCorrect(submission);
